import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { ConnectMcpBody } from './ConnectMcpBody';
import { Panel } from './Panel';

// "Connect your chat client" (arc 101 slice 04, step 1) — the address of the
// control plane, on the page that used to mint a credential for it and never
// name it. `mcp.developerz.ai` speaks OAuth 2.1 + PKCE + RFC 7591 dynamic
// registration and has since before this panel existed; the dashboard simply
// never mentioned it, so every connector had to be set up from the docs.
//
// OAUTH LEADS, THE PAT IS THE FALLBACK — the reverse of what this page shipped.
// A hosted client (Claude.ai, ChatGPT in Developer mode) needs the URL and
// nothing else: it discovers the authorization server itself and the grant mints
// a scoped PAT through the same audited store, which then appears in the list
// below, revocable like any other. Minting by hand first is the headless path —
// CI, a local client, a script — and leading with it asked every reader to
// handle a secret they did not need.
//
// Rendered for EVERY caller, not just one who may mint. Who may mint is the
// server's answer (`mintable_scopes`, `lib/tokens.ts` `canMintTokens`), and the
// copy names those roles off the domain's `mintingRoles()` (`lib/minters.ts`),
// never a typed pair — but the OAuth connector is every caller's to add, and
// hiding the address behind the mint gate would hide half a surface that is
// theirs.
//
// The BODY is `<ConnectMcpBody/>` since epic #3629: the onboarding funnel's
// chat-client step mounts the same content under a card that already carries
// this exact title, and nesting the whole Panel there rendered the identical
// `<h2>` twice. This file is the Panel wrapper the Tokens page mounts.

export function ConnectMcpPanel(): JSX.Element {
  return (
    <Panel title={t('connect_mcp.title')} class="connect-mcp">
      <ConnectMcpBody />
    </Panel>
  );
}
